import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import b2blogo from "../../Asserts/Images/b2blogoo.webp";
import levon_logo from "../../Asserts/Images/levon-techno_logo.webp";
import "./taxinvoice.css";
import { IoIosGlobe } from "react-icons/io";
import { LuPhoneCall } from "react-icons/lu";
import Instance from "../../AxiosConfig";
import { message, Spin } from "antd";
import b2b_seal from "../../Asserts/Images/B2B seal.webp";
import Levon_seal from "../../Asserts/Images/levon seal .webp";
import { ToWords } from "to-words";

const ProformaInvoicePage = (props) => {
  const { id: paramId } = useParams();
  const id = props.id || paramId;

  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleTaxInvoicePage = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await Instance.get(`/proformaInvoices/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        const invoice = response.data?.invoice;
        setInvoiceData(invoice);
        console.log("Fetched invoice:", invoice);
      } else {
        message.error("Failed to fetch invoice data");
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
      message.error("Error fetching invoice");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) handleTaxInvoicePage();
  }, [id]);

  if (loading || !invoiceData) {
    return (
      <div className="text-center mt-5">
        <Spin size="large" />
        <p>Loading Invoice...</p>
      </div>
    );
  }

  const {
    invoiceNo,
    companyDetails,
    companyName,
    address,
    email,
    phone,
    country,
    city,
    ClientName,
    SacCode,
    certificationType,
    gstNumber,
    currency,
    isSplitTax,
    terms = [],
  } = invoiceData;

  const formatDateDDMMYYYY = (dateString) => {
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Total amount in currency (e.g., USD)
  const totalTermAmount = terms.reduce(
    (acc, term) => acc + (term?.termTotal || 0),
    0
  );

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: false,
      ignoreDecimal: true,
      doNotAddOnly: true,
    },
  });
  let totalAmount = 0;

  const baseAmount = terms[0]?.baseAmount || 0;
  const bankingCharge = terms[0]?.BankingCharges || 0; // <-- dynamic

  if (currency?.toUpperCase() === "INR") {
    const gstAmount =
      terms[0]?.gstAmount || Math.round(baseAmount * 0.18);

    totalAmount = baseAmount + gstAmount;
  } else {
    totalAmount = baseAmount + bankingCharge;
  }

  const amountInWords = toWords
    .convert(totalAmount)
    .replace(/\b\w/g, (l) => l.toUpperCase());

  return (
    <div className="invoice-container">
      {/* Header */}
      <div className="invoice-content">
        <div className="tax-invoice-header">
          <div className="contact-details">
            <h6>
              <IoIosGlobe /> www.b2bcert.com
            </h6>
            <h6>
              <LuPhoneCall /> +91 8618629303
            </h6>
          </div>

          <img className="b2b-logo" src={b2blogo} alt="B2B Logo" />

          <div className="header-title">
            <h5>A Division Of</h5>
          </div>

          <img className="b2b-logo" src={levon_logo} alt="Levon Logo" />

          <div className="contact-details">
            <h6>
              <IoIosGlobe /> www.levon-global.com
            </h6>
            <h6>
              <LuPhoneCall /> +91 8618629303
            </h6>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <h6 style={{ fontSize: "16px", fontWeight: "700" }}>
            Date:{" "}
            <span style={{ color: "grey", fontWeight: "500" }}>
              {formatDateDDMMYYYY(invoiceData.proformaInvoiceDate)}
            </span>
          </h6>
        </div>

        <h2 className="invoice-title">PROFORMA INVOICE: {invoiceNo}</h2>

        {/* Bill From / To */}
        <div className="invoice-section">
          <div className="invoice-box">
            <div className="invoice-header">Bill From</div>
            <div className="invoice-body">
              <h4>{companyDetails?.companyName}</h4>
              <p>
                {companyDetails?.addressLine1}, {companyDetails?.addressLine2},{" "}
                {companyDetails?.city}, {companyDetails?.state} -{" "}
                {companyDetails?.pincode}
              </p>
              <p>
                <a href={`mailto:${companyDetails?.email}`}>
                  {companyDetails?.email}
                </a>
              </p>
              <p>
                <strong>{companyDetails?.phone}</strong>
              </p>
              <p>{companyDetails?.gstNumber}</p>
            </div>
          </div>

          <div className="invoice-box">
            <div className="invoice-header">Bill To</div>
            <div className="invoice-body">
              <h4>{companyName}</h4>
              <p>
                {address}, {city}, {country}
              </p>
              <p>{ClientName}</p>
              <p>
                <a href={`mailto:${email}`}>{email}</a>
              </p>
              <p>
                <strong>{phone}</strong>
              </p>
              <p>{gstNumber}</p>
            </div>
          </div>
        </div>

        {/* Table */}
        <table className="invoice-table mt-4">
          <thead className="table-head">
            <tr>
              <th>SL. No.</th>
              <th>Description</th>
              <th>SAC Code</th>
              <th>Price ({currency})</th>
              <th>Total ({currency})</th>
            </tr>
          </thead>

          <tbody>
            {/* Base Closure Row */}
            <tr style={{ backgroundColor: "#f9f9f9" }}>
              <td>1</td>
              <td style={{ fontWeight: "600" }}>{certificationType}</td>
              <td>{SacCode || "—"}</td>
              <td>
                {invoiceData?.baseClosureAmount?.toLocaleString()} {currency}
              </td>
              <td></td>
            </tr>

            {/* Payment Terms */}
            {terms.map((term, index) => {
              const rowNum = index + 2;
              return (
                <tr key={index}>
                  <td>{rowNum}</td>
                  <td>
                    <div style={{ fontWeight: "600" }}>{term.termName}</div>
                    {/* <div style={{ color: "#555" }}>{certificationType}</div> */}
                  </td>
                  <td>{SacCode || "—"}</td>
                  <td>
                    {term.baseAmount?.toLocaleString()} {currency}
                  </td>
                  <td>
                    {term.baseAmount?.toLocaleString()} {currency}
                  </td>
                </tr>
              );
            })}

            {/* 18% GST Row – Only for INR */}
            {/* GST or Banking Charges Row */}
            {(() => {
              const serialNo = terms.length + 2;
              const bankingCharge = terms[0]?.BankingCharges || 0;
              const baseAmount = terms[0]?.baseAmount || 0;

              // 🔥 NON-INR + Banking Charge > 0 → SHOW BANKING CHARGES
              if (currency?.toUpperCase() !== "INR") {
                if (bankingCharge > 0) {
                  return (
                    <tr style={{ backgroundColor: "#f0f8ff" }}>
                      <td>{serialNo}</td>
                      <td style={{ fontWeight: "600" }}>Banking Charges</td>
                      <td></td>
                      <td>
                        {bankingCharge} {currency}
                      </td>
                      <td>
                        {bankingCharge} {currency}
                      </td>
                    </tr>
                  );
                }

                // ❌ NON-INR → No GST should be shown → return null
                return null;
              }

              // INR → Show GST block
              const gstAmount =
                terms[0]?.gstAmount || Math.round(baseAmount * 0.18);

              return (
                <>
                  {!isSplitTax ? (
                    /* IGST */
                    <tr style={{ backgroundColor: "#f0f8ff" }}>
                      <td>{serialNo}</td>
                      <td style={{ fontWeight: "600" }}>IGST 18%</td>
                      <td></td>
                      <td>
                        {gstAmount.toLocaleString()} {currency}
                      </td>
                      <td>
                        {gstAmount.toLocaleString()} {currency}
                      </td>
                    </tr>
                  ) : (
                    <>
                      {/* CGST */}
                      <tr style={{ backgroundColor: "#f0f8ff" }}>
                        <td>{serialNo}</td>
                        <td style={{ fontWeight: "600" }}>CGST 9%</td>
                        <td></td>
                        <td>
                          {(gstAmount / 2).toLocaleString()} {currency}
                        </td>
                        <td>
                          {(gstAmount / 2).toLocaleString()} {currency}
                        </td>
                      </tr>

                      {/* SGST */}
                      <tr style={{ backgroundColor: "#f0f8ff" }}>
                        <td>{serialNo + 1}</td>
                        <td style={{ fontWeight: "600" }}>SGST 9%</td>
                        <td></td>
                        <td>
                          {(gstAmount / 2).toLocaleString()} {currency}
                        </td>
                        <td>
                          {(gstAmount / 2).toLocaleString()} {currency}
                        </td>
                      </tr>
                    </>
                  )}

                  {/* TOTAL GST */}
                  <tr style={{ backgroundColor: "#d9f7be" }}>
                    <td>
                      {isSplitTax ? serialNo + 2 : serialNo + 1}
                    </td>
                    <td style={{ fontWeight: "700" }}>
                      Total GST
                    </td>
                    <td></td>
                    <td style={{ fontWeight: "700" }}>
                      {gstAmount.toLocaleString()} {currency}
                    </td>
                    <td style={{ fontWeight: "700" }}>
                      {gstAmount.toLocaleString()} {currency}
                    </td>
                  </tr>

                </>
              );
            })()}

            {/* Grand Total */}
            <tr className="total-section">
              <td
                colSpan="4"
                className="text-right text-bold"
                style={{ textAlign: "center" }}
              >
                GRAND TOTAL
              </td>
              <td className="text-bold" style={{ fontSize: "20px" }}>
                {totalAmount.toLocaleString()} {currency}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Amount in Words */}
        <div className="amount-section">
          <span>
            <strong>Amount in words:</strong> {amountInWords} {currency}
          </span>
        </div>

        {/* Bank Details */}
        <div className="mt-3 payment-term">
          <h5>Payment Terms :</h5>
          <h4>Bank Transfer Details</h4>
          <div className="mt-4 payment-term-content">
            <div>
              {/* Bank Info */}
              <p>
                <strong>Bank:</strong> {invoiceData?.selectedBank?.bankName}
              </p>

              <p>
                <strong>Account Number:</strong>{" "}
                {invoiceData?.selectedBank?.accountNumber}
              </p>

              <p>
                <strong>Country:</strong>{" "}
                {invoiceData?.selectedBank?.country || "India"}
              </p>

              {/* ✅ INDIA CASE */}
              {invoiceData?.selectedBank?.country === "India" ? (
                <>
                  <p>
                    <strong>IFSC Code:</strong>{" "}
                    {invoiceData?.selectedBank?.ifscCode || "-"}
                  </p>

                  <p>
                    <strong>Beneficiary Name:</strong>{" "}
                    {invoiceData?.selectedBank?.beneficiaryName || "-"}
                  </p>

                  <p>
                    <strong>SWIFT Code:</strong>{" "}
                    {invoiceData?.selectedBank?.swiftCode || "-"}
                  </p>

                  <p>
                    <strong>Bank Address:</strong>{" "}
                    {invoiceData?.selectedBank?.branchAddress || "-"}
                  </p>
                </>
              ) : (
                /* ✅ INTERNATIONAL CASE */
                <>
                  <p>
                    <strong>Account Holder:</strong>{" "}
                    {invoiceData?.selectedBank?.accountHolderName || "-"}
                  </p>

                  <p>
                    <strong>Routing Code:</strong>{" "}
                    {invoiceData?.selectedBank?.routingCode || "-"}
                  </p>

                  <p>
                    <strong>Routing Type:</strong>{" "}
                    {invoiceData?.selectedBank?.routingType || "-"}
                  </p>

                  <p>
                    <strong>Payment Method:</strong>{" "}
                    {invoiceData?.selectedBank?.paymentMethod || "-"}
                  </p>

                  <p>
                    <strong>Bank Address:</strong>{" "}
                    {invoiceData?.selectedBank?.bankAddress || "-"}
                  </p>
                </>
              )}
            </div>

            <div className="seal-section">
              <img className="seal-img" src={b2b_seal} alt="B2B Seal" />
              <img className="seal-img" src={Levon_seal} alt="Levon Seal" />
            </div>
          </div>

          {currency !== "INR" && (
            <h6 className="important-note">
              Important Note:{" "}
              <span>
                1) Remittance should not be made in INR | 2) IGST exempted on
                execution of LUT
              </span>
            </h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProformaInvoicePage;
